@if (showLoading && !isChatHostPage) {
  <app-spinner></app-spinner>
}
@if (messages?.length) {
  <div
    class="app--messages fixed"
    (click)="cleanMessages()"
    (keyup.enter)="cleanMessages()"
    tabindex="0">
    <div class="app--messages--container fixed">
      <p-messages
        [(value)]="messages"
        [escape]="false"
        [enableService]="false"
        [closable]="closableMessage"
        [showTransitionOptions]="'500ms'"
        [hideTransitionOptions]="'500ms'" />
    </div>
  </div>
}

@if (!!isLogged && !isAdmin && !isChatHostPage) {
  <app-floating-chat> </app-floating-chat>
}
@if (showHeader) {
  <app-header [ngClass]="{ statusbar_hidden: statusBarHidden }"></app-header>
}
<main>
  <div
    class="app--main align-items-center justify-content-center"
    [ngClass]="{
      'have-header': showHeader,
      statusbar_hidden: statusBarHidden && !showHeader,
      'chat-host-page': isChatHostPage,
    }">
    <div class="app--main--content-container">
      <div #content class="app--main--content-container--content">
        <router-outlet (activate)="onActivate()"></router-outlet>
      </div>
    </div>
  </div>
  @if (showFooter) {
    <app-footer></app-footer>
  }
</main>
